export const WINDOW = Symbol('Window');
